export default "__VITE_ASSET__8eeaec5c__"